/*
 * Copyright (c) New Cloud Technologies, Ltd., 2013-2022
 *
 * You can not use the contents of the file in any way without New Cloud Technologies, Ltd. written permission.
 * To obtain such a permit, you should contact New Cloud Technologies, Ltd. at http://ncloudtech.com/contact.html
 *
 */

export enum EVENTS {
    init = 'init',
    ready = 'ready',
    error = 'error',
    saveStart = 'saveStart',
    saveEnd = 'saveEnd',
    fallback = 'fallback',
    reload = 'reload',
    redirect = 'redirect',
}
